import { useMemo } from 'react'
import { gql, useQuery } from '@apollo/client'
import { useSites } from 'store'

import { convertDateRange } from '../../hooks/use-traffic'
import { useGetStatsTimeRange } from '../../store'

const OPERATION_TRAFFIC = gql`
  query TrafficDistributionGroupBySite($sfIds: [ID], $startsAt: String, $endsAt: String) {
    stats: trafficDistributionGroupBySite(sf_ids: $sfIds, starts_at: $startsAt, ends_at: $endsAt) {
      site_id
      site_name
      download
      upload
      active_users
    }
  }
`

const useData = () => {
  const [globalRange] = useGetStatsTimeRange()
  const [{ selected }] = useSites()

  const {data, loading} = useQuery(OPERATION_TRAFFIC, {
    variables: {
      sfIds: selected.map(({sf_id}) => sf_id),
      ...convertDateRange(globalRange)
    }
  })

  const formattedData = useMemo(() => {
    if (!data) {
      return []
    }
    return data.stats
      .filter(({download, upload}) => parseInt(download) + parseInt(upload) > 0)
      .map(values => {
        return {
          ...values,
          name: values.site_name,
          download: parseInt(values.download) / 1000,
          upload: parseInt(values.upload) / 1000
        }
      })
  }, [data])

  const sites = useMemo(() => {
    const total = formattedData.reduce((total, {download, upload}) => total + download + upload,0)

    return formattedData.map(data => {
      const percentage = (((data.download + data.upload) * 100) / total).toFixed(1)
      return {
        site_id: data.site_id,
        name: data.site_name,
        percentage,
        total: data.download + data.upload
      }
    })
  }, [formattedData])

  return {
    loading,
    data: sites
  }
}


export default useData